import { Link } from 'react-router-dom';
import './StubPage.css';

export function NotFoundPage() {
  return (
    <main className="stub-page">
      <div className="section-inner">
        <h1>404</h1>
        <p>
          Page not found. <Link to="/">Back to home</Link>.
        </p>
      </div>
    </main>
  );
}
